import React from 'react'
import Styles from './Styles.module.css'
export default function TextBox(props) {
  const { onChange, value, error } = props

  return (
    <div className={Styles.inputWrapper}>
      {props.label ? <label className={props.isRequired ? Styles.required : ''} >{props.label}</label> : null}
      <div className={Styles.inputContainer}>
        <input type="text" disabled={props.disabled} value={value} onChange={e => onChange(e.target.value)} placeholder={props.placeholder} maxLength={props.maxlength} minLength={props.minLength}/>
      </div>
      <div className={Styles.errorWrapper}>
        {error ? <p className={Styles.error}>{error}</p> : null}
      </div>
    </div>
  )
}

// if we have to add date:
{/* <input type={props.label.includes("Date") ? 'Date' : 'text'} disabled={props.disabled} value={value} onChange={e => onChange(e)} placeholder={props.placeholder} /> */}

